import {
  EstadoAgendaCorporativa,
  EstadoFactibilidadCorporativaENUM,
  EstadoPreventaEnum, EstadoProspectoEnum,
  ModulosEnumChoice, TipoBeneficioENUM
} from '../constants';
import {
  Contrato,
  IDataProspecto,
  IDataSolicitudSupercion,
  IReporteVentaCorporativa, MaterialTransferido
} from '../interfaces';
import { UBICACION_EVA_VENTA_CORPORATIVA } from '../interfaces/erp/factibilidad_corporativo';
import { formatDate, formatDateWithTime, formatHour } from './format-date';

export const booleanCellValues = (row: any, key: string): string => {
  const value = row?.original?.[key];
  return !!value ? 'SI' : 'NO';
};

export const booleanCell = (value: boolean): string => {
  return value ? 'SI' : 'NO';
};

export const dateWithTimeCellValues = (row: any, key: string): string => {
  const value = row?.original?.[key];

  return !!value ? formatDateWithTime(value) : 'N/A';
};

export const dateCellValues = (row: any, key: string): string => {
  const value = row?.original?.[key];

  return !!value ? formatDate(value) : 'N/A';
};

export const formatHourCellValue = (row: any, key: string): string => {
  const value = row?.original?.[key];

  return !!value ? formatHour(value) : 'N/A';
};

export const cellIngresoBenificio = (data: IDataProspecto): string => {

  if (!data) return 'N/A'
  if (data.reportado && data.es_reportado)
    return `${TipoBeneficioENUM.REPORTADO_TELCO}, ${TipoBeneficioENUM.REPORTADO},`
  if (data.es_reportado) return TipoBeneficioENUM.REPORTADO
  if (data.reportado) return TipoBeneficioENUM.REPORTADO_TELCO
  if (data.es_curador_tutor) return TipoBeneficioENUM.FAMILIAR_DISCAPACIDAD
  if (data.es_bono_humano) return TipoBeneficioENUM.DESARROLLO_HUMANO
  if (data.es_ayuda_social) return TipoBeneficioENUM.AYUDA_SOCIAL
  if (data.es_gremio) return TipoBeneficioENUM.APLICA_GREMIO

  return 'N/A'
}

export const cellLineaRazonSocial = (contrato: Contrato | null | undefined, razonSocial: string, linea?: number): string => {

  if (linea) return `${razonSocial} - L${linea}`

  if (contrato == null || contrato.linea == null) return razonSocial;

  let value = `${razonSocial} - L${contrato.linea}`

  return value;
}

export const cellNotFilter = {
  disableFilters: true,
  disableGlobalFilter: true,
  enableColumnFilter: false,
  enableSorting: false,
  enableColumnActions: false,
}

type EstadoVenta = {
  modulo: string
  fecha_registro: string
  ultimo_estado: string
}

export const cellEstadoVentaSupervisor = (data: IDataSolicitudSupercion): EstadoVenta => {

  if (data.preagendamiento_data != null)
    return {
      modulo: ModulosEnumChoice.PREAGENDAMIENTO,
      fecha_registro: data.preagendamiento_data.fecha_creacion,
      ultimo_estado: data.preagendamiento_data.estado_preagendamiento
    }


  if (data.preventa_data != null)
    return {
      modulo: ModulosEnumChoice.PREVENTA,
      fecha_registro: data.preventa_data.fecha_creacion,
      ultimo_estado: data.preventa_data.estado_preventa,
    }

  if (data.prospecto_data != null)
    return {
      modulo: ModulosEnumChoice.PROSPECTO,
      fecha_registro: data.prospecto_data.fecha_creacion,
      ultimo_estado: data.prospecto_data.estado_prospecto
    }


  return {
    modulo: 'N/A',
    fecha_registro: 'N/A',
    ultimo_estado: 'N/A'
  }

}

export const cellEstadoReporteVentaCorporativa = (data: IReporteVentaCorporativa): EstadoVenta => {

  if ((data?.agenda_corporativa_data?.length || 0) > 0)
    return {
      modulo: ModulosEnumChoice.AGENDAMIENTO_CORPORATIVO,
      fecha_registro: data.agenda_corporativa_data?.[0]?.fecha_creacion || "",
      ultimo_estado: data.agenda_corporativa_data?.[0]?.estado_agenda || "N/A"
    }

  if ((data?.factibilidad_corporativa_data?.length || 0) > 0)
    return {
      modulo: ModulosEnumChoice.FACTIBILIDAD_CORPORATIVO,
      fecha_registro: data.factibilidad_corporativa_data?.[0]?.fecha_creacion || "",
      ultimo_estado: data.factibilidad_corporativa_data?.[0]?.estado_factibilidad || "N/A"

    }


  if ((data?.preventa_corporativa_data?.length || 0) > 0)
    return {
      modulo: ModulosEnumChoice.PREVENTA_CORPORATIVO,
      fecha_registro: data.preventa_corporativa_data?.[0]?.fecha_creacion || "",
      ultimo_estado: data.preventa_corporativa_data?.[0]?.estado_preventa || "N/A"
    }

  if ((data?.id_prospecto_corporativo?.length || 0) > 0)
    return {
      modulo: ModulosEnumChoice.PROSPECTO_CORPORATIVO,
      fecha_registro: data?.fecha_creacion || "",
      ultimo_estado: data?.estado_prospecto || "N/A",
    }


  return {
    modulo: 'N/A',
    fecha_registro: 'N/A',
    ultimo_estado: 'N/A'
  }

}
interface RespUbicacionVentaCorporativa {
  ubicacion?: string;
  fecha_registro?: string;
}

export const cellUbicacionEvaVentaCorporativa = (data: IReporteVentaCorporativa): RespUbicacionVentaCorporativa => {
  const dataUbicacion: RespUbicacionVentaCorporativa = {}


  if ((data?.agenda_corporativa_data?.length || 0) > 0) {
    const agendamiento = data.agenda_corporativa_data?.[0]

    dataUbicacion.fecha_registro = agendamiento?.fecha_modificacion || "N/A"

    if (agendamiento?.estado_agenda == EstadoAgendaCorporativa.RECORDINADO) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.AGENDAMIENTO_RECOORDINADO
      return dataUbicacion
    }
    if (agendamiento?.estado_agenda == EstadoAgendaCorporativa.APROBADO) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.AGENDAMIENTO_CREADO
      return dataUbicacion
    }
  }

  if ((data?.factibilidad_corporativa_data?.length || 0) > 0) {
    const factibilidad = data.factibilidad_corporativa_data?.[0]
    const preventa = data.preventa_corporativa_data?.[0]

    // =========================================================================
    // PREFACTIBILIDAD - Si la preventa está PREAPROBADA, mostrar estado de prefactibilidad
    // Esto tiene prioridad sobre los estados de factibilidad cuando aún falta completar información
    // =========================================================================
    if (preventa?.estado_preventa == EstadoPreventaEnum.PREAPROBADA
      && preventa?.preventa_aprobada_factibilidad
    ) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.PREFACTIBILIDAD_APROBADA
      return dataUbicacion
    }

    if (
      factibilidad?.estado_factibilidad == EstadoFactibilidadCorporativaENUM.APROBADO
      // && factibilidad.estado_aceptacion
      && factibilidad.revisado_supervisor
      // && factibilidad.revisado_supervisor
      && factibilidad.factibilidad_enviada
    ) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.FACTIBILIDAD_ESPERA_AGENDAMIENTO
      return dataUbicacion
    }

    if (
      (factibilidad?.estado_factibilidad == EstadoFactibilidadCorporativaENUM.APROBADO
        || factibilidad?.estado_factibilidad == EstadoFactibilidadCorporativaENUM.EN_REVISION)
      && factibilidad?.aceptado_factibilidad
      && factibilidad?.preaprobado_inventario
      && factibilidad?.aprobado_supervisor
      && !factibilidad?.aprobado_inventario
    ) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.FACTIBILIDAD_SOLICITADA_APROBACION_FINAL
      return dataUbicacion
    }

    if (
      factibilidad?.estado_factibilidad == EstadoFactibilidadCorporativaENUM.CORREGIDO
      && factibilidad.observaciones?.observacion_revision_supervisor
      && factibilidad.observaciones?.observacion_revision_supervisor?.length > 0
    ) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.FACTIBILIDAD_DOCUMENTOS_CORREGIDOS
      return dataUbicacion
    }

    if (
      factibilidad?.estado_factibilidad == EstadoFactibilidadCorporativaENUM.EN_REVISION
      && factibilidad.observaciones?.observacion_revision_supervisor
      && factibilidad.observaciones?.observacion_revision_supervisor?.length > 0
    ) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.FACTIBILIDAD_SOLICITA_CORRECCION
      return dataUbicacion
    }

    if (
      factibilidad?.estado_factibilidad == EstadoFactibilidadCorporativaENUM.DOCUMENTOS_CARGADOS
    ) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.FACTIBILIDAD_DOCUMENTOS_CARGADOS
      return dataUbicacion
    }

    if (factibilidad?.revisado_supervisor == true
      && factibilidad?.estado_factibilidad == EstadoFactibilidadCorporativaENUM.EN_REVISION
      && !factibilidad?.aprobado_supervisor) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.FACTIBILIDAD_SOLICITA_DOCUMENTOS
      return dataUbicacion
    }

    if (factibilidad?.aceptado_factibilidad
      && factibilidad?.estado_factibilidad == EstadoFactibilidadCorporativaENUM.EN_GESTION
      && factibilidad?.preaprobado_inventario
      && !!!factibilidad?.prospecto_corporativo_data?.condicion_venta
    ) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.FACTIBILIDAD_PENDIENTE_SUPERVISOR
      return dataUbicacion
    }
    // =========================================================================
    // inventario
    // =========================================================================
    if (factibilidad?.aceptado_factibilidad
      && !factibilidad?.preaprobado_inventario
      && (
        factibilidad?.estado_factibilidad == EstadoFactibilidadCorporativaENUM.PENDIENTE
        || factibilidad?.estado_factibilidad == EstadoFactibilidadCorporativaENUM.INSPECCIONADO
      )
    ) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.FACTIBILIDAD_PREAPROBACION_INVENTARIO
      return dataUbicacion
    }

    // =========================================================================
    // NOC FACTIBILIDAD
    // =========================================================================
    if (!factibilidad?.aceptado_factibilidad
      && factibilidad?.estado_factibilidad == EstadoFactibilidadCorporativaENUM.PENDIENTE
    ) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.FACTIBILIDAD_PENDIENTE
      return dataUbicacion
    }

    if (!factibilidad?.aceptado_factibilidad
      && factibilidad?.estado_factibilidad == EstadoFactibilidadCorporativaENUM.INSPECCIONADO
    ) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.FACTIBILIDAD_INSPECCIONADA
      return dataUbicacion
    }

    if (!factibilidad?.aceptado_factibilidad
      && factibilidad?.estado_factibilidad == EstadoFactibilidadCorporativaENUM.EN_INSPECCION
    ) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.FACTIBILIDAD_EN_INSPECCION
      return dataUbicacion
    }
  }


  if ((data?.preventa_corporativa_data?.length || 0) > 0) {
    const preventa = data.preventa_corporativa_data?.[0]

    if (preventa?.estado_preventa == EstadoPreventaEnum.EN_PROCESO
      && preventa?.preventa_aprobada_factibilidad
    ) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.PREFACTIBILIDAD_LLENA
      return dataUbicacion
    }

    if (preventa?.estado_preventa == EstadoPreventaEnum.PREAPROBADA
      && preventa?.preventa_aprobada_factibilidad
    ) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.PREFACTIBILIDAD_APROBADA
      return dataUbicacion
    }

    if (
      preventa?.estado_preventa == EstadoPreventaEnum.EN_ESPERA) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.PREVENTA_EN_ESPERA
      return dataUbicacion
    }

  }

  if (data?.id_prospecto_corporativo) {
    const prospecto = data

    if (prospecto?.estado_prospecto == EstadoProspectoEnum.CANCELADO) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.PROSPECTO_FALLIDO
      return dataUbicacion
    }
    if (prospecto?.estado_prospecto == EstadoProspectoEnum.FINALIZADO) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.PROSPECTO_FINALIZADO
      return dataUbicacion
    }
    if (prospecto?.estado_prospecto == EstadoProspectoEnum.EN_ESPERA) {
      dataUbicacion.ubicacion = UBICACION_EVA_VENTA_CORPORATIVA.PROSPECTO_EN_ESPERA
      return dataUbicacion
    }
  }




  return {
    ubicacion: 'N/A',
    fecha_registro: 'N/A'
  }

}

//**No usar cuando se consume directamente el endpoint */
export function cellStockProductoMetros(data: MaterialTransferido): string {
  const {
    usa_metros,
    producto_data,
    metros_actuales
  } = data;

  if (usa_metros || producto_data?.usa_metros) {
    return metros_actuales ? `${metros_actuales} (METROS)` : '—'
  }

  return producto_data?.stock_actual?.toString() ?? '0'

}